import React from 'react';
import { Icon } from './icons.jsx';
import { Sidebar } from './shell.jsx';
// Integrations Center — apps, tokens, webhooks e API pública
const { useState } = React;

const TOKENS_INITIAL = [
  { id: 'tok_001', label: 'Bling ERP — Loja Exemplo',     appId: 'bling_v2',  tenant: 'Loja Exemplo Premium', tenantId: 42,  masked: 'tz_live_****XAb2', created: '12 Jan 2026', rotated: '01 Mai 2026', lastUsed: 'Há 2h',    status: 'ativo',   scope: ['orders:read','orders:write','catalogue:read'], ip: '189.44.10.2' },
  { id: 'tok_002', label: 'Tiny — Tech Store',            appId: 'tiny_v3',   tenant: 'Tech Store Brasil',    tenantId: 77,  masked: 'tz_live_****mK9', created: '03 Mar 2026', rotated: '03 Mar 2026', lastUsed: 'Há 3 dias', status: 'ativo',   scope: ['orders:read','stock:write'],                   ip: '201.55.40.1' },
  { id: 'tok_003', label: 'Google Merchant — Moda Clara', appId: 'gmc_v1',    tenant: 'Moda Clara',           tenantId: 103, masked: 'tz_live_****pQ7', created: '20 Jan 2026', rotated: '20 Jan 2026', lastUsed: 'Há 5 dias', status: 'suspenso',scope: ['catalogue:read'],                              ip: '—' },
  { id: 'tok_004', label: 'API Admin — Julio',            appId: 'admin_api', tenant: '—',                    tenantId: null,masked: 'tz_adm_****rR3',  created: '01 Dez 2025', rotated: '01 Dez 2025', lastUsed: 'Hoje',      status: 'ativo',   scope: ['*'],                                           ip: '177.142.12.8' },
  { id: 'tok_005', label: 'Bling — Dona Clara Doces',     appId: 'bling_v2',  tenant: 'Dona Clara Doces',     tenantId: 4,   masked: 'tz_live_****sL1', created: '15 Fev 2026', rotated: '15 Fev 2026', lastUsed: 'Há 7 dias', status: 'expirado',scope: ['orders:read','catalogue:read'],                ip: '—' },
];

const APPS_MOCK = [
  { app: 'Bling ERP',       type: 'ERP',       tenant: 'Loja Exemplo Premium', status: 'ativo',    installed: '12 Jan 2026', synced: 'Há 2h',    error: null,             version: 'v2.4.1' },
  { app: 'Tiny ERP',        type: 'ERP',       tenant: 'Tech Store Brasil',    status: 'erro',     installed: '03 Mar 2026', synced: 'Há 3 dias', error: '401 Unauthorized',version: 'v3.1.0' },
  { app: 'Google Merchant', type: 'Marketing', tenant: 'Moda Clara',           status: 'suspenso', installed: '20 Jan 2026', synced: 'Há 5 dias', error: 'Token expirado', version: 'v1.2.0' },
  { app: 'Melhor Envio',    type: 'Frete',     tenant: 'Loja Exemplo Premium', status: 'ativo',    installed: '15 Fev 2026', synced: 'Há 1h',     error: null,             version: 'v2.0.3' },
  { app: 'Mercado Pago',    type: 'Pagamento', tenant: 'Tech Store Brasil',    status: 'ativo',    installed: '03 Mar 2026', synced: 'Há 30min',  error: null,             version: 'v5.1.2' },
  { app: 'PagSeguro',       type: 'Pagamento', tenant: 'Dona Clara Doces',     status: 'ativo',    installed: '28 Mar 2026', synced: 'Há 4h',     error: null,             version: 'v3.0.0' },
];

const WEBHOOKS_MOCK = [
  { tenant: 'Loja Exemplo Premium', event: 'order.created',    url: 'https://api.bling.com.br/webhook/orders',  status: 'ativo',   delivered: 'Há 2h',    rate: '99.2%', retry: null },
  { tenant: 'Tech Store Brasil',    event: 'order.paid',       url: 'https://api.tiny.com.br/webhooks/order',   status: 'falha',   delivered: 'Há 3 dias', rate: '61.0%', retry: 'Em 15min' },
  { tenant: 'Dona Clara Doces',     event: 'product.updated',  url: 'https://hooks.zapier.com/hooks/catch/abc', status: 'ativo',   delivered: 'Há 1h',    rate: '100%',  retry: null },
  { tenant: 'Moda Clara',           event: 'customer.created', url: 'https://gmc.google.com/feed/tezus/103',    status: 'pausado', delivered: 'Há 5 dias', rate: '72.3%', retry: null },
];

const API_LOGS_MOCK = [
  { ts: 'Hoje, 14:22', tenant: 'Loja Exemplo Premium', appId: 'bling_v2',  endpoint: '/api/v1/orders/',    method: 'GET',  status: 200, latency: '94ms',  ip: '189.44.10.2',  reqId: 'req_aA1' },
  { ts: 'Hoje, 14:20', tenant: 'Tech Store Brasil',    appId: 'tiny_v3',   endpoint: '/api/v1/stock/',     method: 'POST', status: 401, latency: '12ms',  ip: '201.55.40.1',  reqId: 'req_bB2' },
  { ts: 'Hoje, 14:18', tenant: 'Loja Exemplo Premium', appId: 'bling_v2',  endpoint: '/api/v1/catalogue/', method: 'GET',  status: 200, latency: '138ms', ip: '189.44.10.2',  reqId: 'req_cC3' },
  { ts: 'Hoje, 14:15', tenant: '—',                   appId: 'admin_api', endpoint: '/api/admin/tenants/',method: 'GET',  status: 200, latency: '44ms',  ip: '177.142.12.8', reqId: 'req_dD4' },
  { ts: 'Hoje, 13:55', tenant: 'Dona Clara Doces',     appId: 'bling_v2',  endpoint: '/api/v1/orders/1042/',method:'GET',  status: 200, latency: '78ms',  ip: '189.44.10.2',  reqId: 'req_eE5' },
  { ts: 'Hoje, 13:40', tenant: 'Moda Clara',           appId: 'gmc_v1',    endpoint: '/api/v1/catalogue/', method: 'GET',  status: 403, latency: '8ms',   ip: '—',            reqId: 'req_fF6' },
];

const TOKEN_STATUS = {
  ativo:    { cls: 'success', label: 'Ativo' },
  expirado: { cls: 'warning', label: 'Expirado' },
  suspenso: { cls: 'neutral', label: 'Suspenso' },
  revogado: { cls: 'danger',  label: 'Revogado' },
};
const APP_STATUS = {
  ativo:     { cls: 'success', label: 'Ativo' },
  erro:      { cls: 'danger',  label: 'Erro' },
  suspenso:  { cls: 'neutral', label: 'Suspenso' },
  instalando:{ cls: 'info',    label: 'Instalando' },
};

// ── Tab bar ──────────────────────────────────────────────────────────────────
const IntTabs = ({ tabs, active, onChange }) => (
  <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 24 }}>
    {tabs.map(t => (
      <button key={t.id} onClick={() => onChange(t.id)} style={{
        padding: '9px 16px', border: 'none', background: 'transparent',
        fontSize: 13, fontWeight: active === t.id ? 600 : 500,
        color: active === t.id ? 'var(--text)' : 'var(--text-muted)',
        borderBottom: active === t.id ? '2px solid var(--brand-navy)' : '2px solid transparent',
        marginBottom: -1, cursor: 'pointer', transition: 'color 120ms',
      }}>
        {t.label}
        {t.count !== undefined && (
          <span style={{ marginLeft: 6, fontSize: 11, fontWeight: 600, background: active === t.id ? 'var(--brand-navy)' : 'var(--bg-subtle)', color: active === t.id ? 'white' : 'var(--text-muted)', padding: '1px 6px', borderRadius: 10 }}>{t.count}</span>
        )}
      </button>
    ))}
  </div>
);

// ── Token Security Modal (view full token) ───────────────────────────────────
const TokenSecurityModal = ({ open, token, onClose, logAction, onToast }) => {
  const [motivo, setMotivo]     = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [revealed, setRevealed]  = useState(false);
  if (!open || !token) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 460, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <div style={{ width: 38, height: 38, borderRadius: 8, background: 'var(--danger-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="key" size={18} style={{ color: 'var(--danger)' }} />
          </div>
          <div><div style={{ fontWeight: 700, fontSize: 15 }}>Visualizar token completo</div><div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{token.label} · {token.tenant}</div></div>
          <button className="icon-action" style={{ marginLeft: 'auto' }} onClick={onClose}><Icon name="x" size={16} /></button>
        </div>
        <div style={{ padding: '16px 22px' }}>
          <div style={{ padding: '10px 12px', background: 'var(--danger-bg)', borderRadius: 8, fontSize: 13, color: 'var(--danger)', marginBottom: 14, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
            <Icon name="alert" size={14} style={{ flexShrink: 0, marginTop: 1 }} />
            Esta ação será registrada na auditoria. Nunca compartilhe tokens em logs ou chats.
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo <span style={{ color: 'var(--danger)' }}>*</span></label>
            <input value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Ex: Verificar token no ambiente do cliente" style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
          </div>
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', marginBottom: 14 }}>
            <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 15, height: 15 }} />
            <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Entendo que esta ação será auditada permanentemente.</span>
          </label>
          {revealed && (
            <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontFamily: 'JetBrains Mono, monospace', fontSize: 13, color: 'var(--text)', marginBottom: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
              <span style={{ flex: 1, wordBreak: 'break-all' }}>tz_live_xK2mPqRsLnVbHjOuAeCwFiGd{token.id}</span>
              <button className="btn sm" onClick={() => navigator.clipboard?.writeText('tz_live_example')}><Icon name="copy" size={12} /></button>
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          <button className="btn" onClick={onClose}>Cancelar</button>
          {!revealed
            ? <button className="btn danger" disabled={!motivo.trim() || !confirmed} onClick={() => { setRevealed(true); logAction && logAction({ acao: `Token visualizado: ${token.label}`, loja: token.tenant, kind: 'danger' }); onToast && onToast('Token revelado — ação registrada na auditoria'); }}>
                <Icon name="key" size={14} />Revelar token
              </button>
            : <button className="btn" onClick={onClose}>Fechar</button>
          }
        </div>
      </div>
    </div>
  );
};

// ── Full API Documentation Modal ─────────────────────────────────────────────
const FullApiDocModal = ({ open, onClose }) => {
  const [section, setSection] = useState('autenticacao');
  if (!open) return null;

  const SECTIONS = [
    { id: 'autenticacao', label: 'Autenticação' },
    { id: 'ambientes',    label: 'Ambientes' },
    { id: 'endpoints',    label: 'Endpoints' },
    { id: 'webhooks',     label: 'Webhooks' },
    { id: 'erros',        label: 'Erros comuns' },
    { id: 'rate_limits',  label: 'Rate limits' },
    { id: 'curl',         label: 'Exemplos cURL' },
    { id: 'json',         label: 'Exemplos JSON' },
  ];

  const Code = ({ children }) => (
    <pre style={{ margin: '8px 0', padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', border: '1px solid var(--border)', overflowX: 'auto', lineHeight: 1.7, whiteSpace: 'pre' }}>{children}</pre>
  );

  const H = ({ children }) => <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8, marginTop: 18, color: 'var(--text)' }}>{children}</div>;
  const P = ({ children }) => <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, margin: '0 0 10px' }}>{children}</p>;

  const CONTENT = {
    autenticacao: (
      <div>
        <H>Bearer Token</H>
        <P>Todas as requisições à API Tezus devem incluir um token de autenticação no header <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, background: 'var(--bg-subtle)', padding: '1px 5px', borderRadius: 3 }}>Authorization</code>.</P>
        <Code>{`Authorization: Bearer tz_live_xK2mPqRs****`}</Code>
        <H>Tipos de token</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 12 }}>
          {[['tz_live_*','Token de produção — acesso real aos dados da loja','success'],['tz_sand_*','Token de sandbox — dados isolados para testes','info'],['tz_adm_*','Token administrativo — escopo total (Super Admin)','danger']].map(([prefix,desc,cls],i) => (
            <div key={i} style={{ padding: '10px 14px', borderBottom: i < 2 ? '1px solid var(--border)' : 'none', display: 'flex', alignItems: 'center', gap: 12 }}>
              <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, background: 'var(--bg-subtle)', padding: '2px 7px', borderRadius: 4, flexShrink: 0 }}>{prefix}</code>
              <span style={{ fontSize: 13, color: 'var(--text-secondary)', flex: 1 }}>{desc}</span>
              <span className={`badge ${cls}`}><span className="dot" />{cls === 'danger' ? 'Admin' : cls === 'info' ? 'Sandbox' : 'Live'}</span>
            </div>
          ))}
        </div>
        <H>Scopes disponíveis</H>
        <P>Tokens podem ter escopos restritos. Configure ao criar um novo token.</P>
        <Code>{`orders:read    — Leitura de pedidos
orders:write   — Criação e atualização de pedidos
catalogue      — Acesso ao catálogo de produtos
events         — Registro de eventos customizados
search         — Busca de produtos
webhooks       — Gerenciamento de webhooks
*              — Acesso total (apenas tokens admin)`}</Code>
      </div>
    ),
    ambientes: (
      <div>
        <H>Produção</H>
        <Code>{`Base URL: https://api.tezus.com.br`}</Code>
        <P>Ambiente de produção com dados reais. Use tokens <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>tz_live_*</code>.</P>
        <H>Sandbox</H>
        <Code>{`Base URL: https://sandbox.api.tezus.com.br`}</Code>
        <P>Ambiente isolado para testes e integrações. Dados não afetam produção. Use tokens <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>tz_sand_*</code>.</P>
        <H>Versionamento</H>
        <P>A API é versionada pela URL. A versão atual é <strong>v1</strong>.</P>
        <Code>{`https://api.tezus.com.br/api/v1/
https://api.tezus.com.br/admin/api/`}</Code>
      </div>
    ),
    endpoints: (
      <div>
        <H>Pedidos</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
          {[['GET','/api/v1/orders/','Lista pedidos do tenant'],['POST','/api/v1/orders/','Cria pedido'],['GET','/api/v1/orders/{id}/','Detalhe do pedido'],['PATCH','/api/v1/orders/{id}/','Atualiza status'],].map(([m,p,d],i,arr) => (
            <div key={i} style={{ padding: '10px 14px', borderBottom: i<arr.length-1?'1px solid var(--border)':'none', display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, fontWeight:700, fontFamily:'JetBrains Mono, monospace', background:m==='GET'?'var(--info-bg)':'var(--success-bg)', color:m==='GET'?'var(--info)':'var(--success)', padding:'2px 7px', borderRadius:4, flexShrink:0, width:40, textAlign:'center' }}>{m}</span>
              <code style={{ flex:1, fontSize:12, fontFamily:'JetBrains Mono, monospace', color:'var(--text-secondary)' }}>{p}</code>
              <span style={{ fontSize:11, color:'var(--text-muted)' }}>{d}</span>
            </div>
          ))}
        </div>
        <H>Catálogo</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
          {[['GET','/api/v1/catalogue/','Lista produtos'],['POST','/api/v1/catalogue/','Cria produto'],['PUT','/api/v1/catalogue/{id}/','Atualiza produto'],['DELETE','/api/v1/catalogue/{id}/','Remove produto'],].map(([m,p,d],i,arr) => (
            <div key={i} style={{ padding: '10px 14px', borderBottom: i<arr.length-1?'1px solid var(--border)':'none', display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, fontWeight:700, fontFamily:'JetBrains Mono, monospace', background:m==='GET'?'var(--info-bg)':m==='DELETE'?'var(--danger-bg)':'var(--success-bg)', color:m==='GET'?'var(--info)':m==='DELETE'?'var(--danger)':'var(--success)', padding:'2px 7px', borderRadius:4, flexShrink:0, width:40, textAlign:'center' }}>{m}</span>
              <code style={{ flex:1, fontSize:12, fontFamily:'JetBrains Mono, monospace', color:'var(--text-secondary)' }}>{p}</code>
              <span style={{ fontSize:11, color:'var(--text-muted)' }}>{d}</span>
            </div>
          ))}
        </div>
        <H>Admin</H>
        <Code>{`GET  /admin/api/tenants/      — Lista tenants (requer tz_adm_*)
GET  /admin/api/tenants/{id}/ — Detalhe do tenant
GET  /admin/api/events/       — Log de eventos`}</Code>
      </div>
    ),
    webhooks: (
      <div>
        <H>Eventos disponíveis</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 14 }}>
          {[['order.created','Pedido criado'],['order.paid','Pedido pago'],['order.cancelled','Pedido cancelado'],['product.updated','Produto atualizado'],['customer.created','Novo cliente'],['subscription.changed','Assinatura alterada'],].map(([ev,d],i,arr) => (
            <div key={i} style={{ padding: '9px 14px', borderBottom: i<arr.length-1?'1px solid var(--border)':'none', display:'flex', gap:12, alignItems:'center' }}>
              <code style={{ fontFamily:'JetBrains Mono, monospace', fontSize:12, background:'var(--bg-subtle)', padding:'2px 7px', borderRadius:4 }}>{ev}</code>
              <span style={{ fontSize:12, color:'var(--text-secondary)' }}>{d}</span>
            </div>
          ))}
        </div>
        <H>Payload padrão</H>
        <Code>{`{
  "event": "order.created",
  "timestamp": "2026-05-31T14:22:00Z",
  "tenant_id": 42,
  "data": { ... }
}`}</Code>
        <H>Segurança</H>
        <P>Todas as chamadas incluem o header <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>X-Tezus-Signature</code> com HMAC-SHA256 do payload para validação.</P>
      </div>
    ),
    erros: (
      <div>
        <H>Códigos de erro</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 14 }}>
          {[['400','Bad Request','Parâmetros inválidos na requisição'],['401','Unauthorized','Token ausente, expirado ou inválido'],['403','Forbidden','Token sem permissão para o recurso'],['404','Not Found','Recurso não encontrado'],['422','Unprocessable Entity','Erro de validação nos dados'],['429','Too Many Requests','Limite de requisições excedido'],['500','Internal Server Error','Erro inesperado no servidor'],].map(([code,label,desc],i,arr) => (
            <div key={i} style={{ padding: '10px 14px', borderBottom: i<arr.length-1?'1px solid var(--border)':'none', display:'flex', alignItems:'center', gap:12 }}>
              <span style={{ fontFamily:'JetBrains Mono, monospace', fontSize:12, fontWeight:700, color:code.startsWith('4')||code.startsWith('5')?'var(--danger)':'var(--text)', flexShrink:0, width:36 }}>{code}</span>
              <span style={{ fontSize:12, fontWeight:600, flexShrink:0, width:160 }}>{label}</span>
              <span style={{ fontSize:12, color:'var(--text-muted)' }}>{desc}</span>
            </div>
          ))}
        </div>
        <H>Formato de erro</H>
        <Code>{`{
  "error": "authentication_failed",
  "message": "Token inválido ou expirado.",
  "code": 401,
  "request_id": "req_abc123"
}`}</Code>
      </div>
    ),
    rate_limits: (
      <div>
        <H>Limites por plano</H>
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 14 }}>
          {[['Basic','100 req/min','1.000 req/hora'],['Pro','500 req/min','10.000 req/hora'],['Enterprise','2.000 req/min','Sem limite/hora'],['Admin','5.000 req/min','Sem limite'],].map(([plan,rpm,rph],i,arr) => (
            <div key={i} style={{ padding: '10px 14px', borderBottom: i<arr.length-1?'1px solid var(--border)':'none', display:'flex', alignItems:'center', gap:12 }}>
              <span style={{ fontWeight:600, fontSize:13, flex:1 }}>{plan}</span>
              <code style={{ fontFamily:'JetBrains Mono, monospace', fontSize:11, background:'var(--bg-subtle)', padding:'2px 8px', borderRadius:4 }}>{rpm}</code>
              <code style={{ fontFamily:'JetBrains Mono, monospace', fontSize:11, background:'var(--bg-subtle)', padding:'2px 8px', borderRadius:4 }}>{rph}</code>
            </div>
          ))}
        </div>
        <H>Headers de resposta</H>
        <Code>{`X-RateLimit-Limit: 500
X-RateLimit-Remaining: 487
X-RateLimit-Reset: 1717159200`}</Code>
        <P>Quando o limite é excedido, a API retorna HTTP 429 e o header <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>Retry-After</code> com o tempo em segundos para a próxima tentativa.</P>
      </div>
    ),
    curl: (
      <div>
        <H>Listar pedidos</H>
        <Code>{`curl -X GET "https://api.tezus.com.br/api/v1/orders/" \\
  -H "Authorization: Bearer tz_live_xK2mPqRs****" \\
  -H "Content-Type: application/json"`}</Code>
        <H>Criar pedido</H>
        <Code>{`curl -X POST "https://api.tezus.com.br/api/v1/orders/" \\
  -H "Authorization: Bearer tz_live_xK2mPqRs****" \\
  -H "Content-Type: application/json" \\
  -d '{"customer_id": 12, "items": [{"product_id": 42, "qty": 1}]}'`}</Code>
        <H>Listar produtos</H>
        <Code>{`curl -X GET "https://api.tezus.com.br/api/v1/catalogue/?search=camiseta" \\
  -H "Authorization: Bearer tz_live_xK2mPqRs****"`}</Code>
        <H>Sandbox</H>
        <Code>{`curl -X GET "https://sandbox.api.tezus.com.br/api/v1/orders/" \\
  -H "Authorization: Bearer tz_sand_testToken****"`}</Code>
      </div>
    ),
    json: (
      <div>
        <H>Resposta: lista de pedidos</H>
        <Code>{`{
  "count": 42,
  "next": "https://api.tezus.com.br/api/v1/orders/?page=2",
  "previous": null,
  "results": [
    {
      "id": 1042,
      "status": "paid",
      "total": 189.90,
      "customer": { "id": 12, "name": "João Silva", "email": "joao@email.com" },
      "items": [{ "product_id": 42, "name": "Camiseta P", "qty": 1, "price": 189.90 }],
      "created_at": "2026-05-31T14:22:00Z",
      "paid_at": "2026-05-31T14:23:10Z"
    }
  ]
}`}</Code>
        <H>Resposta: erro de validação</H>
        <Code>{`{
  "error": "validation_error",
  "message": "Dados inválidos na requisição.",
  "fields": {
    "customer_id": ["Este campo é obrigatório."],
    "items": ["Deve conter ao menos um item."]
  },
  "code": 422
}`}</Code>
      </div>
    ),
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(5px)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 900, height: '88vh', background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ padding: '16px 22px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="bookOpen" size={17} style={{ color: 'var(--info)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 16 }}>Documentação completa — Tezus API</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
              <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11 }}>https://docs.tezus.com.br/api</code>
            </div>
          </div>
          <button className="btn sm" onClick={() => navigator.clipboard?.writeText('https://docs.tezus.com.br/api')} title="Copiar URL da documentação"><Icon name="copy" size={13} />Copiar link</button>
          <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          {/* Sidebar nav */}
          <div style={{ width: 180, borderRight: '1px solid var(--border)', padding: '12px 8px', background: 'var(--bg-subtle)', flexShrink: 0, overflowY: 'auto' }}>
            {SECTIONS.map(s => (
              <button key={s.id} onClick={() => setSection(s.id)} style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '8px 12px', borderRadius: 7, border: 'none', background: section === s.id ? 'var(--bg-elevated)' : 'transparent', color: section === s.id ? 'var(--text)' : 'var(--text-muted)', fontSize: 13, fontWeight: section === s.id ? 600 : 400, cursor: 'pointer', textAlign: 'left', marginBottom: 2, boxShadow: section === s.id ? 'var(--shadow-sm)' : 'none', transition: 'all 120ms' }}>
                {s.label}
              </button>
            ))}
          </div>

          {/* Content */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
            {CONTENT[section]}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', borderTop: '1px solid var(--border)', display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Tezus REST API v1 · docs.tezus.com.br/api</span>
          <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
};

// ── API Documentation Drawer ─────────────────────────────────────────────────
const ApiDocDrawer = ({ open, onClose, onToast }) => {
  const [fullDocOpen, setFullDocOpen] = useState(false);
  const [env,        setEnv]        = useState('producao');
  const [auth,       setAuth]       = useState('bearer');
  const [copiedUrl,  setCopiedUrl]  = useState(false);
  const [copiedCurl, setCopiedCurl] = useState(false);

  if (!open) return null;

  const baseUrl  = env === 'producao' ? 'https://api.tezus.com.br' : 'https://sandbox.api.tezus.com.br';
  const tokenEx  = auth === 'bearer'  ? 'tz_live_xK2mPqRs****'     : 'pk_live_3nM8rT****';
  const curlEx   = `curl -X GET "${baseUrl}/admin/api/orders/" \\\n  -H "Authorization: Bearer ${tokenEx}" \\\n  -H "Content-Type: application/json"`;
  const respEx   = `{\n  "count": 42,\n  "next": null,\n  "results": [\n    { "id": 1042, "status": "paid", "total": 189.90,\n      "created_at": "2026-05-31T14:22:00Z" }\n  ]\n}`;

  const ENDPOINTS = [
    { method: 'GET',  path: '/admin/api/orders/',    desc: 'Lista pedidos do tenant' },
    { method: 'GET',  path: '/admin/api/catalogue/', desc: 'Catálogo de produtos' },
    { method: 'POST', path: '/api/v1/events/',       desc: 'Registrar evento' },
    { method: 'GET',  path: '/api/v1/search/',       desc: 'Busca de produtos' },
  ];

  const copyUrl  = () => { navigator.clipboard?.writeText(baseUrl);  setCopiedUrl(true);  setTimeout(() => setCopiedUrl(false),  2200); };
  const copyCurl = () => { navigator.clipboard?.writeText(curlEx);   setCopiedCurl(true); setTimeout(() => setCopiedCurl(false), 2200); };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.4)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 600, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="terminal" size={17} style={{ color: 'var(--info)' }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Documentação da API</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Tezus REST API — v1</div>
          </div>
          <button className="icon-action" style={{ marginLeft: 'auto' }} onClick={onClose}><Icon name="x" size={16} /></button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px' }}>
          {/* Toggles */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 22 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Ambiente</div>
              <div style={{ display: 'flex', gap: 4 }}>
                {[['producao','Produção'],['sandbox','Sandbox']].map(([v,l]) => (
                  <button key={v} onClick={() => setEnv(v)} style={{ padding: '5px 14px', borderRadius: 6, border: '1px solid', borderColor: env === v ? 'var(--brand-navy)' : 'var(--border)', background: env === v ? 'var(--brand-navy)' : 'transparent', color: env === v ? 'white' : 'var(--text-secondary)', fontSize: 12, fontWeight: 500, cursor: 'pointer', transition: 'all 120ms' }}>{l}</button>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Autenticação</div>
              <div style={{ display: 'flex', gap: 4 }}>
                {[['bearer','Bearer Token'],['public','Public Token']].map(([v,l]) => (
                  <button key={v} onClick={() => setAuth(v)} style={{ padding: '5px 14px', borderRadius: 6, border: '1px solid', borderColor: auth === v ? 'var(--brand-navy)' : 'var(--border)', background: auth === v ? 'var(--brand-navy)' : 'transparent', color: auth === v ? 'white' : 'var(--text-secondary)', fontSize: 12, fontWeight: 500, cursor: 'pointer', transition: 'all 120ms' }}>{l}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Base URL */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Base URL</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', background: 'var(--bg-subtle)', borderRadius: 8, border: '1px solid var(--border)' }}>
              <code style={{ flex: 1, fontSize: 13, fontFamily: 'JetBrains Mono, monospace', color: env === 'producao' ? 'var(--success)' : 'var(--warning)' }}>{baseUrl}</code>
              <button className="btn sm" onClick={copyUrl}>
                <Icon name={copiedUrl ? 'check' : 'copy'} size={12} />{copiedUrl ? 'Copiado' : 'Copiar'}
              </button>
            </div>
          </div>

          {/* Endpoints */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Endpoints</div>
            <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
              {ENDPOINTS.map((ep, i) => (
                <div key={i} style={{ padding: '10px 14px', borderBottom: i < ENDPOINTS.length - 1 ? '1px solid var(--border)' : 'none', display: 'flex', alignItems: 'center', gap: 10, background: 'var(--bg-elevated)' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, fontFamily: 'JetBrains Mono, monospace', background: ep.method === 'GET' ? 'var(--info-bg)' : 'var(--success-bg)', color: ep.method === 'GET' ? 'var(--info)' : 'var(--success)', padding: '2px 7px', borderRadius: 4, flexShrink: 0 }}>{ep.method}</span>
                  <code style={{ flex: 1, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>{ep.path}</code>
                  <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{ep.desc}</span>
                </div>
              ))}
            </div>
          </div>

          {/* cURL */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 7 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)' }}>Exemplo de request (cURL)</div>
              <button className="btn sm" onClick={copyCurl}><Icon name={copiedCurl ? 'check' : 'copy'} size={12} />{copiedCurl ? 'Copiado' : 'Copiar cURL'}</button>
            </div>
            <pre style={{ margin: 0, padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', lineHeight: 1.7, border: '1px solid var(--border)', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlEx}</pre>
          </div>

          {/* Response */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Exemplo de response</div>
            <pre style={{ margin: 0, padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', lineHeight: 1.7, border: '1px solid var(--border)', whiteSpace: 'pre-wrap' }}>{respEx}</pre>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          <button className="btn" onClick={onClose}>Fechar</button>
          <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={() => setFullDocOpen(true)}>
            <Icon name="bookOpen" size={14} />Documentação completa
          </button>
        </div>
      </div>
      <FullApiDocModal open={fullDocOpen} onClose={() => setFullDocOpen(false)} />
    </div>
  );
};

// ── Rotate Tokens Modal ──────────────────────────────────────────────────────
const RotateTokensModal = ({ open, onClose, onRotated, onToast, logAction }) => {
  const [scope,         setScope]         = useState('selected');
  const [tenant,        setTenant]        = useState('');
  const [notifyEmail,   setNotifyEmail]   = useState(true);
  const [registerAudit, setRegisterAudit] = useState(true);
  const [confirmText,   setConfirmText]   = useState('');
  const [running,       setRunning]       = useState(false);
  const [done,          setDone]          = useState(false);
  const [newMasked,     setNewMasked]     = useState('');

  if (!open) return null;

  const canSubmit = confirmText === 'ROTACIONAR';

  const handleRotate = () => {
    if (!canSubmit) return;
    setRunning(true);
    setTimeout(() => {
      const rand = Math.random().toString(36).substr(2, 4).toUpperCase();
      setNewMasked(`tz_live_****${rand}`);
      setRunning(false);
      setDone(true);
      logAction && logAction({ acao: `Tokens rotacionados (${scope})`, loja: tenant || '—', kind: 'info' });
      onRotated && onRotated();
    }, 2000);
  };

  const handleClose = () => {
    setScope('selected'); setTenant(''); setNotifyEmail(true); setRegisterAudit(true);
    setConfirmText(''); setRunning(false); setDone(false); setNewMasked('');
    onClose();
  };

  return (
    <div onClick={done ? undefined : handleClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 520, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'center' }}>
          <div style={{ width: 38, height: 38, borderRadius: 8, background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="refresh" size={18} style={{ color: 'var(--warning)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Rotacionar tokens de API?</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>Ação sensível — impacto imediato nas integrações</div>
          </div>
          {!running && !done && <button className="icon-action" onClick={handleClose}><Icon name="x" size={16} /></button>}
        </div>

        <div style={{ padding: '16px 22px' }}>
          {!running && !done && (
            <>
              <div style={{ padding: '10px 12px', background: 'var(--warning-bg)', borderRadius: 8, fontSize: 13, color: 'var(--warning)', marginBottom: 16, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                <Icon name="alert" size={14} style={{ flexShrink: 0, marginTop: 1 }} />
                <span>Tokens ativos serão substituídos. Integrações usando tokens antigos podem parar até serem atualizadas.</span>
              </div>

              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8 }}>Escopo da rotação</div>
                {[['selected','Rotacionar token selecionado'],['expired','Rotacionar todos os tokens expirados'],['tenant','Rotacionar todos os tokens de um tenant']].map(([v,l]) => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '5px 0' }}>
                    <input type="radio" name="rot_scope" checked={scope === v} onChange={() => setScope(v)} style={{ accentColor: 'var(--brand-navy)' }} />
                    <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{l}</span>
                  </label>
                ))}
              </div>

              {scope === 'tenant' && (
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Tenant</label>
                  <input value={tenant} onChange={e => setTenant(e.target.value)} placeholder="Nome ou ID do tenant…" style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, marginBottom: 14 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                  <input type="checkbox" checked={notifyEmail} onChange={e => setNotifyEmail(e.target.checked)} style={{ accentColor: 'var(--brand-navy)' }} />
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Notificar responsáveis por e-mail</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                  <input type="checkbox" checked={registerAudit} onChange={e => setRegisterAudit(e.target.checked)} style={{ accentColor: 'var(--brand-navy)' }} />
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Registrar em auditoria</span>
                </label>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>
                  Digite <code style={{ fontFamily: 'JetBrains Mono, monospace', background: 'var(--bg-subtle)', padding: '1px 5px', borderRadius: 3, fontSize: 11 }}>ROTACIONAR</code> para confirmar
                </label>
                <input value={confirmText} onChange={e => setConfirmText(e.target.value)} placeholder="ROTACIONAR" style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: `1px solid ${canSubmit ? 'var(--success)' : 'var(--border-strong)'}`, background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.04em', transition: 'border-color 150ms' }} />
              </div>
            </>
          )}

          {running && (
            <div style={{ textAlign: 'center', padding: '28px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600, fontSize: 15 }}>Rotacionando tokens…</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>Invalidando tokens antigos e gerando novos…</div>
            </div>
          )}

          {done && (
            <div>
              <div style={{ textAlign: 'center', padding: '16px 0 14px' }}>
                <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                  <Icon name="check" size={22} style={{ color: 'var(--success)' }} />
                </div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>Tokens rotacionados com sucesso</div>
                <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>Última rotação: agora · {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</div>
              </div>
              <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Novo token gerado</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <code style={{ flex: 1, fontSize: 13, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{newMasked}</code>
                  <span className="badge success"><span className="dot" />Ativo</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {!done && !running && (
            <>
              <button className="btn" onClick={handleClose}>Cancelar</button>
              <button className="btn danger" disabled={!canSubmit} onClick={handleRotate} style={{ opacity: canSubmit ? 1 : 0.45 }}>
                <Icon name="refresh" size={14} />Rotacionar tokens
              </button>
            </>
          )}
          {done && <button className="btn primary" onClick={handleClose}>Concluir</button>}
        </div>
      </div>
    </div>
  );
};

// ── New Token Drawer ─────────────────────────────────────────────────────────
const NewTokenDrawer = ({ open, onClose, onCreated, logAction }) => {
  const SCOPES_LIST = [
    ['orders:read','Leitura de pedidos'],['orders:write','Escrita de pedidos'],
    ['catalogue','Catálogo'],['events','Eventos'],['search','Busca'],['webhooks','Webhooks'],
  ];
  const EXPIRY_OPTS = [['7','7 dias'],['30','30 dias'],['90','90 dias'],['0','Sem expiração']];

  const [name,       setName]       = useState('');
  const [tenant,     setTenant]     = useState('');
  const [scopes,     setScopes]     = useState([]);
  const [expiry,     setExpiry]     = useState('30');
  const [env,        setEnv]        = useState('producao');
  const [obs,        setObs]        = useState('');
  const [creating,   setCreating]   = useState(false);
  const [created,    setCreated]    = useState(null);
  const [copiedTok,  setCopiedTok]  = useState(false);

  if (!open) return null;

  const canCreate   = name.trim() && scopes.length > 0;
  const toggleScope = v => setScopes(s => s.includes(v) ? s.filter(x => x !== v) : [...s, v]);

  const handleCreate = () => {
    if (!canCreate) return;
    setCreating(true);
    setTimeout(() => {
      const full = 'tz_live_' + Math.random().toString(36).substr(2, 18);
      const tok = {
        id: 'tok_' + Date.now(),
        label: name + (tenant ? ` — ${tenant}` : ''),
        appId: 'api_manual', tenant: tenant || '—', tenantId: null,
        masked: full.substring(0, 12) + '****',
        created: 'Agora', rotated: 'Agora', lastUsed: 'Nunca',
        status: 'ativo', scope: scopes, ip: '—', _full: full,
      };
      setCreating(false);
      setCreated(tok);
      logAction && logAction({ acao: `Token criado: ${name}`, loja: tenant || '—', kind: 'info' });
      onCreated && onCreated(tok);
    }, 1400);
  };

  const handleClose = () => {
    setName(''); setTenant(''); setScopes([]); setExpiry('30'); setEnv('producao'); setObs('');
    setCreating(false); setCreated(null); setCopiedTok(false);
    onClose();
  };

  return (
    <div onClick={created ? undefined : handleClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.4)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="plus" size={17} style={{ color: 'var(--info)' }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Novo token de API</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Preencha os dados para criar um token</div>
          </div>
          {!creating && !created && <button className="icon-action" style={{ marginLeft: 'auto' }} onClick={handleClose}><Icon name="x" size={16} /></button>}
        </div>

        {!creating && !created && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Nome do token <span style={{ color: 'var(--danger)' }}>*</span></label>
              <input value={name} onChange={e => setName(e.target.value)} placeholder="Ex: Bling ERP — Loja Principal" style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Tenant / Loja</label>
              <input value={tenant} onChange={e => setTenant(e.target.value)} placeholder="Nome do tenant (opcional)" style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8 }}>Escopo <span style={{ color: 'var(--danger)' }}>*</span></label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                {SCOPES_LIST.map(([v,l]) => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '7px 10px', borderRadius: 6, border: '1px solid', borderColor: scopes.includes(v) ? 'var(--brand-navy)' : 'var(--border)', background: scopes.includes(v) ? 'color-mix(in srgb, var(--brand-navy) 8%, transparent)' : 'transparent', transition: 'all 120ms' }}>
                    <input type="checkbox" checked={scopes.includes(v)} onChange={() => toggleScope(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                    <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{l}</span>
                  </label>
                ))}
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Expiração</label>
                <select className="select" style={{ width: '100%' }} value={expiry} onChange={e => setExpiry(e.target.value)}>
                  {EXPIRY_OPTS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Ambiente</label>
                <select className="select" style={{ width: '100%' }} value={env} onChange={e => setEnv(e.target.value)}>
                  <option value="producao">Produção</option>
                  <option value="sandbox">Sandbox</option>
                </select>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Observação interna</label>
              <textarea value={obs} onChange={e => setObs(e.target.value)} placeholder="Notas internas sobre este token…" style={{ width: '100%', height: 64, padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'none' }} />
            </div>
          </div>
        )}

        {creating && (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14 }}>
            <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite' }} />
            <div style={{ fontWeight: 600 }}>Criando token…</div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Gerando chave segura e registrando na auditoria</div>
          </div>
        )}

        {created && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px' }}>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <Icon name="check" size={22} style={{ color: 'var(--success)' }} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>Token criado com sucesso</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>{created.label}</div>
            </div>
            <div style={{ padding: '10px 12px', background: 'var(--warning-bg)', borderRadius: 8, marginBottom: 16, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
              <Icon name="alert" size={14} style={{ color: 'var(--warning)', flexShrink: 0, marginTop: 1 }} />
              <span style={{ fontSize: 13, color: 'var(--warning)', fontWeight: 500 }}>Copie este token agora. Ele não será exibido novamente.</span>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Token gerado</div>
              <div style={{ padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8, border: '1px solid var(--border)', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                <code style={{ flex: 1, fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text)', wordBreak: 'break-all', lineHeight: 1.6 }}>{created._full}</code>
                <button className={`btn sm ${copiedTok ? '' : 'primary'}`} onClick={() => { navigator.clipboard?.writeText(created._full); setCopiedTok(true); setTimeout(() => setCopiedTok(false), 3000); }} style={{ flexShrink: 0 }}>
                  <Icon name={copiedTok ? 'check' : 'copy'} size={12} />{copiedTok ? 'Copiado!' : 'Copiar'}
                </button>
              </div>
            </div>
            <div style={{ background: 'var(--bg-subtle)', borderRadius: 8, padding: '12px 14px', border: '1px solid var(--border)' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8 }}>Detalhes</div>
              {[['Escopo',created.scope.join(', ')],['Ambiente',env==='producao'?'Produção':'Sandbox'],['Expiração',EXPIRY_OPTS.find(([v])=>v===expiry)?.[1]||'—'],['Tenant',tenant||'—']].map(([k,v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '5px 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ color: 'var(--text-muted)' }}>{k}</span>
                  <span style={{ color: 'var(--text)', fontWeight: 500, maxWidth: 240, textAlign: 'right' }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          {!created && !creating && (
            <>
              <button className="btn" onClick={handleClose}>Cancelar</button>
              <button className="btn primary" disabled={!canCreate} onClick={handleCreate} style={{ opacity: canCreate ? 1 : 0.5 }}>
                <Icon name="key" size={14} />Criar token
              </button>
            </>
          )}
          {created && <button className="btn primary" onClick={handleClose}>Concluir</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Reprocessar Integração ───────────────────────────────────────────
const ReprocessIntegrationModal = ({ open, app, onClose, onConfirm }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open || !app) return null;

  const handleConfirm = () => {
    setStep(1);
    setTimeout(() => { setStep(2); onConfirm && onConfirm(app); }, 2200);
  };

  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.44)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 440, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="refresh" size={16} style={{ color: 'var(--info)' }} /></div>
          <div style={{ flex: 1 }}><div style={{ fontWeight: 600, fontSize: 15 }}>Reprocessar integração</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{app.app} · {app.tenant}</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15} /></button>}
        </div>
        <div style={{ padding: '18px 22px' }}>
          {step === 0 && (
            <>
              <div style={{ padding: '10px 12px', background: 'var(--info-bg)', borderRadius: 8, fontSize: 13, color: 'var(--info)', marginBottom: 16, display: 'flex', gap: 8 }}><Icon name="refresh" size={13} style={{ flexShrink: 0, marginTop: 1 }} />Forçará uma nova sincronização e atualizará a última execução.</div>
              {[['App', app.app], ['Tenant', app.tenant], ['Tipo', app.type], ['Versão', app.version], ['Último erro', app.error || 'Nenhum']].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{k}</span>
                  <span style={{ fontWeight: 500, color: k === 'Último erro' && v !== 'Nenhum' ? 'var(--danger)' : 'var(--text)' }}>{v}</span>
                </div>
              ))}
            </>
          )}
          {step === 1 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Reprocessando integração…</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 8 }}>{app.app} → {app.tenant}</div>
            </div>
          )}
          {step === 2 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="check" size={22} style={{ color: 'var(--success)' }} /></div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Integração reprocessada</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>Sincronizado · Última execução: agora</div>
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', borderTop: '1px solid var(--border)', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleConfirm}><Icon name="refresh" size={13} />Reprocessar</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13} />Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Reinstalar App ─────────────────────────────────────────────────────
const ReinstallAppModal = ({ open, app, onClose, onConfirm }) => {
  const [confirmed, setConfirmed] = useState(false);
  const [step,      setStep]      = useState(0);
  React.useEffect(() => { if (!open) { setStep(0); setConfirmed(false); } }, [open]);
  if (!open || !app) return null;

  const handleReinstall = () => {
    setStep(1);
    setTimeout(() => { setStep(2); onConfirm && onConfirm(app); }, 2600);
  };

  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 460, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="package" size={16} style={{ color: 'var(--warning)' }} /></div>
          <div style={{ flex: 1 }}><div style={{ fontWeight: 600, fontSize: 15 }}>Reinstalar app</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{app.app} · {app.tenant}</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15} /></button>}
        </div>
        <div style={{ padding: '18px 22px' }}>
          {step === 0 && (
            <>
              <div style={{ padding: '12px 14px', background: 'var(--warning-bg)', borderRadius: 8, fontSize: 13, color: 'var(--warning)', marginBottom: 16, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                <Icon name="alert" size={14} style={{ flexShrink: 0, marginTop: 1 }} />
                A reinstalação pode recriar webhooks e atualizar credenciais. O app ficará temporariamente indisponível.
              </div>
              {[['App', app.app], ['Tenant', app.tenant], ['Versão atual', app.version]].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{k}</span>
                  <span style={{ fontWeight: 500 }}>{v}</span>
                </div>
              ))}
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', marginTop: 16, padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} style={{ accentColor: 'var(--brand-navy)', width: 15, height: 15 }} />
                <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Confirmo que entendo o impacto desta reinstalação.</span>
              </label>
            </>
          )}
          {step === 1 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Reinstalando app…</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 8 }}>Recriando webhooks e atualizando credenciais</div>
            </div>
          )}
          {step === 2 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="check" size={22} style={{ color: 'var(--success)' }} /></div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>App reinstalado</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>{app.app} · Reinstalado agora</div>
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', borderTop: '1px solid var(--border)', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" disabled={!confirmed} onClick={handleReinstall} style={{ opacity: confirmed ? 1 : 0.5 }}><Icon name="package" size={13} />Reinstalar</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13} />Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Drawer: Configurar App ────────────────────────────────────────────────────
const ConfigureAppDrawer = ({ open, app, onClose, onSave }) => {
  const INIT = { status: 'ativo', ambiente: 'producao', webhooks: true, scopes: ['orders:read', 'orders:write'], callbackUrl: '', saving: false, saved: false };
  const [cfg, setCfg] = useState(INIT);
  const set = (k, v) => setCfg(c => ({ ...c, [k]: v }));

  React.useEffect(() => { if (!open) setCfg(INIT); }, [open]);
  if (!open || !app) return null;

  const ALL_SCOPES = ['orders:read', 'orders:write', 'catalogue', 'events', 'search', 'webhooks'];
  const toggleScope = v => set('scopes', cfg.scopes.includes(v) ? cfg.scopes.filter(s => s !== v) : [...cfg.scopes, v]);

  const handleSave = () => {
    set('saving', true);
    setTimeout(() => { set('saving', false); set('saved', true); onSave && onSave(app, cfg); }, 1200);
  };

  return (
    <div onClick={cfg.saving ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.4)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 520, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="settings" size={16} style={{ color: 'var(--info)' }} /></div>
          <div style={{ flex: 1 }}><div style={{ fontWeight: 700, fontSize: 15 }}>Configurar app</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{app.app} · {app.tenant}</div></div>
          {!cfg.saving && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 18 }}>
          {cfg.saved && (
            <div style={{ padding: '10px 14px', background: 'var(--success-bg)', borderRadius: 8, fontSize: 13, color: 'var(--success)', display: 'flex', gap: 8, alignItems: 'center' }}>
              <Icon name="check" size={13} />Configurações salvas · Última configuração: agora
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Status</label>
              <div style={{ display: 'flex', gap: 4 }}>
                {['ativo', 'inativo'].map(v => (
                  <button key={v} onClick={() => set('status', v)} style={{ flex: 1, padding: '7px', borderRadius: 6, border: `1.5px solid ${cfg.status === v ? 'var(--brand-navy)' : 'var(--border)'}`, background: cfg.status === v ? 'var(--brand-navy)' : 'transparent', color: cfg.status === v ? 'white' : 'var(--text-secondary)', fontSize: 12, fontWeight: 600, cursor: 'pointer', textAlign: 'center', textTransform: 'capitalize', transition: 'all 120ms' }}>{v}</button>
                ))}
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Ambiente</label>
              <select className="select" style={{ width: '100%' }} value={cfg.ambiente} onChange={e => set('ambiente', e.target.value)}>
                <option value="producao">Produção</option>
                <option value="sandbox">Sandbox</option>
                <option value="staging">Staging</option>
              </select>
            </div>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Permissões / Scopes</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              {ALL_SCOPES.map(v => (
                <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '7px 10px', borderRadius: 6, border: '1px solid', borderColor: cfg.scopes.includes(v) ? 'var(--brand-navy)' : 'var(--border)', background: cfg.scopes.includes(v) ? 'color-mix(in srgb, var(--brand-navy) 8%, transparent)' : 'transparent', transition: 'all 120ms' }}>
                  <input type="checkbox" checked={cfg.scopes.includes(v)} onChange={() => toggleScope(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                  <code style={{ fontSize: 11, color: 'var(--text-secondary)', fontFamily: 'JetBrains Mono, monospace' }}>{v}</code>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>URL de callback</label>
            <input value={cfg.callbackUrl} onChange={e => set('callbackUrl', e.target.value)} placeholder={`https://api.${app.app.toLowerCase().replace(/\s/g,'-')}.com/webhook/tezus`} style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
            <input type="checkbox" checked={cfg.webhooks} onChange={e => set('webhooks', e.target.checked)} style={{ accentColor: 'var(--brand-navy)', width: 14, height: 14 }} />
            <span style={{ fontWeight: 500 }}>Webhooks ativos</span>
          </label>
          <div style={{ padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4 }}>Tenant relacionado</div>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{app.tenant}</div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Versão instalada: {app.version}</div>
          </div>
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          <button className="btn" onClick={onClose}>Cancelar</button>
          <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={handleSave} disabled={cfg.saving}>
            {cfg.saving ? <><div style={{ width: 12, height: 12, borderRadius: '50%', border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Salvando…</> : <><Icon name="check" size={13} />Salvar configuração</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Testar Webhook ────────────────────────────────────────────────────
const WebhookTestModal = ({ open, webhook, onClose, onToast }) => {
  const [testing, setTesting] = useState(false);
  const [result,  setResult]  = useState(null);
  React.useEffect(() => { if (!open) { setTesting(false); setResult(null); } }, [open]);
  if (!open || !webhook) return null;

  const PAYLOAD = JSON.stringify({ event: webhook.event, timestamp: new Date().toISOString(), tenant_id: 42, data: { id: 1042, status: 'created', total: 189.90 } }, null, 2);

  const runTest = () => {
    setTesting(true); setResult(null);
    setTimeout(() => {
      const ok = Math.random() > 0.25;
      const ms = Math.floor(Math.random() * 220 + 70);
      setTesting(false);
      setResult({ ok, status: ok ? 200 : 500, time: ms + 'ms', body: ok ? '{"received":true,"status":"ok"}' : '{"error":"Internal Server Error"}', ts: new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit', second:'2-digit' }) });
      onToast && onToast(`Webhook testado · ${ok ? 'Sucesso' : 'Falha'} (${ms}ms)`);
    }, 1600);
  };

  return (
    <div onClick={testing ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:560,maxHeight:'88vh',background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',display:'flex',flexDirection:'column',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12,flexShrink:0 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="zap" size={16} style={{ color:'var(--info)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Testar webhook</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>{webhook.tenant} · <code style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11 }}>{webhook.event}</code></div></div>
          {!testing && <button className="icon-action" onClick={onClose}><Icon name="x" size={16}/></button>}
        </div>
        <div style={{ flex:1,overflowY:'auto',padding:'18px 22px',display:'flex',flexDirection:'column',gap:14 }}>
          <div>
            <div style={{ fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Endpoint</div>
            <code style={{ fontSize:11,fontFamily:'JetBrains Mono, monospace',color:'var(--text-secondary)',background:'var(--bg-subtle)',padding:'8px 12px',borderRadius:8,display:'block',wordBreak:'break-all',border:'1px solid var(--border)' }}>{webhook.url}</code>
          </div>
          <div>
            <div style={{ fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Payload de teste</div>
            <pre style={{ margin:0,padding:'12px 14px',background:'var(--bg-subtle)',borderRadius:8,fontSize:11,fontFamily:'JetBrains Mono, monospace',color:'var(--text-secondary)',border:'1px solid var(--border)',overflowX:'auto',lineHeight:1.6,whiteSpace:'pre-wrap',maxHeight:150 }}>{PAYLOAD}</pre>
          </div>
          {testing && <div style={{ textAlign:'center',padding:'20px 0' }}>
            <div style={{ width:38,height:38,borderRadius:'50%',border:'3px solid var(--border)',borderTop:'3px solid var(--brand-navy)',animation:'spin 0.8s linear infinite',margin:'0 auto 12px' }}/>
            <div style={{ fontSize:13,fontWeight:600 }}>Enviando para endpoint…</div>
          </div>}
          {result && <div style={{ padding:'14px 16px',background:result.ok?'var(--success-bg)':'var(--danger-bg)',borderRadius:10,border:`1px solid color-mix(in srgb,${result.ok?'var(--success)':'var(--danger)'} 25%,transparent)` }}>
            <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:10 }}>
              <Icon name={result.ok?'check':'x'} size={16} style={{ color:result.ok?'var(--success)':'var(--danger)' }}/>
              <span style={{ fontWeight:700,fontSize:14,color:result.ok?'var(--success)':'var(--danger)' }}>{result.ok ? 'Sucesso' : 'Falha'}</span>
            </div>
            {[['Status HTTP', <code key="s" style={{ fontFamily:'JetBrains Mono, monospace',fontWeight:700,fontSize:13,color:result.ok?'var(--success)':'var(--danger)' }}>{result.status}</code>], ['Tempo de resposta', result.time], ['Timestamp', result.ts]].map(([k, v]) => (
              <div key={k} style={{ display:'flex',justifyContent:'space-between',fontSize:12,padding:'5px 0',borderBottom:'1px solid color-mix(in srgb,currentColor 10%,transparent)' }}>
                <span style={{ opacity:.7 }}>{k}</span><span style={{ fontWeight:500 }}>{v}</span>
              </div>
            ))}
            <div style={{ marginTop:8,fontSize:11,fontFamily:'JetBrains Mono, monospace',opacity:.8 }}>Response: {result.body}</div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end',flexShrink:0 }}>
          <button className="btn" onClick={onClose}>Fechar</button>
          <button className="btn primary" onClick={runTest} disabled={testing}>
            {testing ? <><div style={{ width:12,height:12,borderRadius:'50%',border:'2px solid rgba(255,255,255,.3)',borderTop:'2px solid white',animation:'spin 0.8s linear infinite' }}/>Testando…</> : <><Icon name="zap" size={13}/>{result ? 'Executar novamente' : 'Enviar teste'}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Reenviar Webhook ──────────────────────────────────────────────────
const WebhookResendModal = ({ open, webhook, onClose, onConfirm }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open || !webhook) return null;
  const handleConfirm = () => { setStep(1); setTimeout(() => { setStep(2); onConfirm && onConfirm(webhook); }, 2000); };
  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="refresh" size={16} style={{ color:'var(--warning)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Reenviar evento</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>{webhook.tenant}</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {step === 0 && <>
            {[['Evento', <code key="e" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11,background:'var(--info-bg)',color:'var(--info)',padding:'2px 7px',borderRadius:4 }}>{webhook.event}</code>], ['Tenant', webhook.tenant], ['Endpoint', <code key="u" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:10,color:'var(--text-muted)' }}>{webhook.url.slice(0,50)}…</code>], ['Última tentativa', webhook.delivered], ['Erro anterior', webhook.status === 'falha' ? <span key="err" style={{ color:'var(--danger)',fontSize:12 }}>Falha na entrega</span> : '—']].map(([k, v]) => (
              <div key={k} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid var(--border)',fontSize:13 }}>
                <span style={{ color:'var(--text-muted)',fontSize:12 }}>{k}</span><span style={{ fontWeight:500 }}>{v}</span>
              </div>
            ))}
          </>}
          {step === 1 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:44,height:44,borderRadius:'50%',border:'3px solid var(--border)',borderTop:'3px solid var(--brand-navy)',animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600 }}>Reenviando evento…</div>
            <div style={{ fontSize:12,color:'var(--text-muted)',marginTop:8 }}>{webhook.event} → {webhook.tenant}</div>
          </div>}
          {step === 2 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:'var(--success-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px' }}><Icon name="check" size={22} style={{ color:'var(--success)' }}/></div>
            <div style={{ fontWeight:700,fontSize:15 }}>Evento reenviado!</div>
            <div style={{ fontSize:13,color:'var(--text-muted)',marginTop:6 }}>Status: <strong>Entregue</strong> · Última tentativa: agora</div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleConfirm}><Icon name="refresh" size={13}/>Reenviar evento</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13}/>Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Drawer: Editar Webhook ────────────────────────────────────────────────────
const WebhookEditDrawer = ({ open, webhook, onClose, onSave }) => {
  const EVENTS_LIST = ['order.created','order.paid','order.cancelled','product.updated','customer.created','subscription.changed'];
  const INIT = { nome:'', endpoint:'', events:[], status:'ativo', secret:'', ambiente:'producao', headers:'' };
  const [form,   setForm]   = useState(INIT);
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const toggleEv = v => set('events', form.events.includes(v) ? form.events.filter(x => x !== v) : [...form.events, v]);

  React.useEffect(() => {
    if (open && webhook) {
      setForm({ nome: `${webhook.tenant} — ${webhook.event}`, endpoint: webhook.url, events: [webhook.event], status: webhook.status === 'pausado' ? 'inativo' : 'ativo', secret: '••••••••••••••••', ambiente: 'producao', headers: '' });
      setSaving(false); setSaved(false);
    }
    if (!open) { setSaving(false); setSaved(false); }
  }, [open]);

  if (!open || !webhook) return null;

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSaved(true); onSave && onSave(webhook, form); }, 1200);
  };

  return (
    <div onClick={saving ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.4)',backdropFilter:'blur(3px)',zIndex:9999,display:'flex',alignItems:'stretch',justifyContent:'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width:520,background:'var(--bg-elevated)',boxShadow:'-4px 0 32px rgba(0,0,0,0.18)',display:'flex',flexDirection:'column' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12,flexShrink:0 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="edit" size={16} style={{ color:'var(--info)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Editar webhook</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>{webhook.tenant}</div></div>
          {!saving && <button className="icon-action" onClick={onClose}><Icon name="x" size={16}/></button>}
        </div>
        <div style={{ flex:1,overflowY:'auto',padding:'20px 22px',display:'flex',flexDirection:'column',gap:14 }}>
          {saved && <div style={{ padding:'10px 14px',background:'var(--success-bg)',borderRadius:8,fontSize:13,color:'var(--success)',display:'flex',gap:8,alignItems:'center' }}><Icon name="check" size={13}/>Webhook atualizado · Última edição: agora</div>}
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Nome</label>
            <input value={form.nome} onChange={e => set('nome', e.target.value)} style={{ width:'100%',height:36,padding:'0 12px',borderRadius:8,border:'1px solid var(--border-strong)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }}/>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Endpoint</label>
            <input value={form.endpoint} onChange={e => set('endpoint', e.target.value)} style={{ width:'100%',height:36,padding:'0 12px',borderRadius:8,border:'1px solid var(--border-strong)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:12,fontFamily:'JetBrains Mono, monospace' }}/>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:8 }}>Eventos inscritos</label>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:6 }}>
              {EVENTS_LIST.map(ev => (
                <label key={ev} style={{ display:'flex',alignItems:'center',gap:7,cursor:'pointer',padding:'6px 10px',borderRadius:6,border:'1px solid',borderColor:form.events.includes(ev)?'var(--brand-navy)':'var(--border)',background:form.events.includes(ev)?'color-mix(in srgb,var(--brand-navy) 8%,transparent)':'transparent',transition:'all 120ms' }}>
                  <input type="checkbox" checked={form.events.includes(ev)} onChange={() => toggleEv(ev)} style={{ accentColor:'var(--brand-navy)',flexShrink:0 }}/>
                  <code style={{ fontSize:10,color:'var(--text-secondary)',fontFamily:'JetBrains Mono, monospace' }}>{ev}</code>
                </label>
              ))}
            </div>
          </div>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12 }}>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:7 }}>Status</label>
              <div style={{ display:'flex',gap:4 }}>
                {['ativo','inativo'].map(v => (
                  <button key={v} onClick={() => set('status', v)} style={{ flex:1,padding:'7px',borderRadius:6,border:`1.5px solid ${form.status===v?'var(--brand-navy)':'var(--border)'}`,background:form.status===v?'var(--brand-navy)':'transparent',color:form.status===v?'white':'var(--text-secondary)',fontSize:12,fontWeight:600,cursor:'pointer',textAlign:'center',textTransform:'capitalize',transition:'all 120ms' }}>{v}</button>
                ))}
              </div>
            </div>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:7 }}>Ambiente</label>
              <select className="select" style={{ width:'100%' }} value={form.ambiente} onChange={e => set('ambiente', e.target.value)}>
                <option value="producao">Produção</option>
                <option value="sandbox">Sandbox</option>
              </select>
            </div>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Segredo / Assinatura <span style={{ fontWeight:400,color:'var(--text-muted)' }}>(mascarado)</span></label>
            <input value={form.secret} onChange={e => set('secret', e.target.value)} type="password" style={{ width:'100%',height:36,padding:'0 12px',borderRadius:8,border:'1px solid var(--border-strong)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }}/>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:6 }}>Headers customizados <span style={{ fontWeight:400,color:'var(--text-muted)' }}>(JSON, opcional)</span></label>
            <textarea value={form.headers} onChange={e => set('headers', e.target.value)} placeholder='{"X-Custom-Header":"valor"}' style={{ width:'100%',minHeight:56,padding:'8px 12px',border:'1px solid var(--border-strong)',borderRadius:8,background:'var(--bg-elevated)',color:'var(--text)',fontSize:12,fontFamily:'JetBrains Mono, monospace',resize:'vertical',lineHeight:1.5 }}/>
          </div>
        </div>
        <div style={{ padding:'12px 22px',background:'var(--bg-subtle)',display:'flex',gap:8,borderTop:'1px solid var(--border)',flexShrink:0 }}>
          <button className="btn" onClick={onClose}>Cancelar</button>
          <button className="btn primary" style={{ marginLeft:'auto' }} onClick={handleSave} disabled={saving}>
            {saving ? <><div style={{ width:12,height:12,borderRadius:'50%',border:'2px solid rgba(255,255,255,.3)',borderTop:'2px solid white',animation:'spin 0.8s linear infinite' }}/>Salvando…</> : <><Icon name="check" size={13}/>Salvar webhook</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Pausar / Reativar Webhook ─────────────────────────────────────────
const WebhookPauseModal = ({ open, webhook, isPaused, onClose, onConfirm }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open || !webhook) return null;
  const action = isPaused ? 'Reativar' : 'Pausar';
  const handleConfirm = () => { setStep(1); setTimeout(() => { setStep(2); onConfirm && onConfirm(webhook); }, 1400); };
  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:isPaused?'var(--success-bg)':'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name={isPaused?'play':'suspend'} size={16} style={{ color:isPaused?'var(--success)':'var(--warning)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>{action} webhook</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>{webhook.tenant}</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {step === 0 && <>
            {!isPaused && <div style={{ padding:'10px 12px',background:'var(--warning-bg)',borderRadius:8,fontSize:13,color:'var(--warning)',marginBottom:16,display:'flex',gap:8,alignItems:'flex-start' }}>
              <Icon name="alert" size={14} style={{ flexShrink:0,marginTop:1 }}/>
              Eventos deixarão de ser enviados para este endpoint até que o webhook seja reativado.
            </div>}
            {[['Evento', <code key="e" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11,background:'var(--info-bg)',color:'var(--info)',padding:'2px 7px',borderRadius:4 }}>{webhook.event}</code>], ['Tenant', webhook.tenant], ['Status atual', webhook.status], ['Taxa de sucesso', webhook.rate]].map(([k, v]) => (
              <div key={k} style={{ display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid var(--border)',fontSize:13 }}>
                <span style={{ color:'var(--text-muted)',fontSize:12 }}>{k}</span><span style={{ fontWeight:500 }}>{v}</span>
              </div>
            ))}
          </>}
          {step === 1 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:44,height:44,borderRadius:'50%',border:'3px solid var(--border)',borderTop:`3px solid ${isPaused?'var(--success)':'var(--warning)'}`,animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600 }}>{isPaused ? 'Reativando' : 'Pausando'} webhook…</div>
          </div>}
          {step === 2 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:isPaused?'var(--success-bg)':'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px' }}><Icon name={isPaused?'check':'suspend'} size={22} style={{ color:isPaused?'var(--success)':'var(--warning)' }}/></div>
            <div style={{ fontWeight:700,fontSize:15 }}>Webhook {isPaused ? 'reativado' : 'pausado'}!</div>
            <div style={{ fontSize:13,color:'var(--text-muted)',marginTop:6 }}>Status: <strong>{isPaused ? 'Ativo' : 'Pausado'}</strong></div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className={`btn ${isPaused?'primary':'danger'}`} onClick={handleConfirm}><Icon name={isPaused?'play':'suspend'} size={13}/>{action} webhook</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13}/>Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Integrations Page ────────────────────────────────────────────────────────
const IntegrationsPage = ({ onToast, logAction, tenantContext }) => {
  const [tab,           setTab]           = useState(tenantContext ? 'tokens' : 'overview');
  const [tokenModal,    setTokenModal]    = useState(null);
  const [reprocessApp,  setReprocessApp]  = useState(null);
  const [reinstallApp,  setReinstallApp]  = useState(null);
  const [configureApp,  setConfigureApp]  = useState(null);
  const [appsLocal,     setAppsLocal]     = useState({});
  const [onlyErrors,    setOnlyErrors]    = useState(false);
  const [failuresFilter,setFailuresFilter]= useState(false);
  const [apiDocOpen,    setApiDocOpen]    = useState(false);
  const [rotateOpen,    setRotateOpen]    = useState(false);
  const [newTokenOpen,  setNewTokenOpen]  = useState(false);
  const [tokens,        setTokens]        = useState(TOKENS_INITIAL);
  const [lastRotation,  setLastRotation]  = useState(null);
  const [tenantFilter,  setTenantFilter]  = useState(tenantContext || null);
  const [webhookTest,   setWebhookTest]   = useState(null);
  const [webhookResend, setWebhookResend] = useState(null);
  const [webhookEdit,   setWebhookEdit]   = useState(null);
  const [webhookPause,  setWebhookPause]  = useState(null); // { webhook, isPaused }
  const [webhooksLocal, setWebhooksLocal] = useState({});

  const failureCount = APPS_MOCK.filter(a => a.status === 'erro').length + WEBHOOKS_MOCK.filter(w => w.status === 'falha').length;
  const filteredApps = failuresFilter ? APPS_MOCK.filter(a => a.status === 'erro' || a.status === 'suspenso') : APPS_MOCK;

  const TABS = [
    { id: 'overview',  label: 'Visão geral' },
    { id: 'tokens',    label: 'Tokens públicos', count: tokens.length },
    { id: 'apps',      label: 'Apps conectados', count: APPS_MOCK.length },
    { id: 'webhooks',  label: 'Webhooks',         count: WEBHOOKS_MOCK.length },
    { id: 'logs',      label: 'Logs de API' },
    { id: 'security',  label: 'Segurança' },
  ];

  const handleTabChange = id => { setTab(id); if (id !== 'apps') setFailuresFilter(false); };

  const handleVerFalhas = () => { setFailuresFilter(true); setTab('apps'); };

  const handleRotated = () => {
    const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    setLastRotation(now);
    setTokens(prev => prev.map(t => t.status === 'ativo'
      ? { ...t, rotated: 'Agora', masked: `tz_live_****${Math.random().toString(36).substr(2,3).toUpperCase()}` }
      : t
    ));
    onToast && onToast('Tokens rotacionados com sucesso');
  };

  const kpis = [
    { label: 'Tokens ativos',      value: tokens.filter(t => t.status === 'ativo').length,   icon: 'key' },
    { label: 'Tokens expirados',   value: tokens.filter(t => t.status === 'expirado').length, icon: 'alert', warn: true },
    { label: 'Apps conectados',    value: APPS_MOCK.filter(a => a.status === 'ativo').length,  icon: 'package' },
    { label: 'Falhas (24h)',        value: API_LOGS_MOCK.filter(l => l.status >= 400).length,  icon: 'x', danger: true },
    { label: 'Sem rotação há 90d', value: 2,       icon: 'clock', warn: true },
    { label: 'Requisições hoje',   value: '1.842', icon: 'activity' },
  ];

  const OVERVIEW_APPS = [
    { name: 'Bling ERP',       tenants: 2, errors: 0, lastReq: 'Há 2h',    rate: '99.2%', icon: '🔗' },
    { name: 'Tiny ERP',        tenants: 1, errors: 3, lastReq: 'Há 3 dias', rate: '61.0%', icon: '🔗' },
    { name: 'Google Merchant', tenants: 1, errors: 1, lastReq: 'Há 5 dias', rate: '80.0%', icon: '🛍' },
    { name: 'Melhor Envio',    tenants: 1, errors: 0, lastReq: 'Há 1h',    rate: '100%',  icon: '🚚' },
    { name: 'Mercado Pago',    tenants: 1, errors: 0, lastReq: 'Há 30min',  rate: '100%',  icon: '💳' },
    { name: 'API Admin',       tenants: 0, errors: 0, lastReq: 'Há 5min',   rate: '100%',  icon: '⚙️' },
  ];

  return (
    <div className="content wide" style={{ maxWidth: 1280 }}>
      <div className="page-header">
        <div>
          <h1>Integrations Center</h1>
          <p className="sub">Apps, tokens públicos, autenticação da API e integrações externas.</p>
        </div>
        <div className="actions">
          <button className="btn" onClick={() => setApiDocOpen(true)}><Icon name="terminal" size={14} />Documentação API</button>
          <button className="btn" onClick={handleVerFalhas}>
            <Icon name="alert" size={14} />Ver falhas
            {failureCount > 0 && <span style={{ marginLeft: 3, fontWeight: 700, color: 'var(--danger)', fontSize: 12 }}>({failureCount})</span>}
          </button>
          <button className="btn" onClick={() => setRotateOpen(true)}><Icon name="refresh" size={14} />Rotacionar tokens</button>
          <button className="btn primary" onClick={() => setNewTokenOpen(true)}><Icon name="plus" size={14} />Novo token</button>
        </div>
      </div>

      {/* Banner de tenantContext vindo de Repairs */}
      {tenantFilter && (
        <div style={{ background: 'color-mix(in srgb, var(--info) 8%, var(--bg-elevated))', border: '1px solid color-mix(in srgb, var(--info) 30%, var(--border))', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="key" size={15} style={{ color: 'var(--info)' }} />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>Tokens filtrados para <strong>{tenantFilter.name}</strong></div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>Exibindo apenas tokens associados a este tenant</div>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, background: 'var(--info-bg)', color: 'var(--info)', fontSize: 12, fontWeight: 600 }}>
              <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--info)' }} />
              Tenant: {tenantFilter.name}
            </span>
            <button className="btn sm" onClick={() => { setTenantFilter(null); setTab('overview'); }}>
              <Icon name="x" size={12} />Limpar filtro
            </button>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 24 }}>
        {kpis.map(k => (
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14} />{k.label}</div>
            <div className="value" style={{ color: k.danger ? 'var(--danger)' : k.warn ? 'var(--warning)' : undefined }}>{k.value}</div>
          </div>
        ))}
      </div>

      <IntTabs tabs={TABS} active={tab} onChange={handleTabChange} />

      {/* Failures filter chip */}
      {failuresFilter && tab === 'apps' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', background: 'var(--danger-bg)', borderRadius: 20, fontSize: 12, fontWeight: 600, color: 'var(--danger)', border: '1px solid color-mix(in srgb, var(--danger) 25%, transparent)' }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--danger)', display: 'inline-block' }} />
            Com falhas · {filteredApps.length} {filteredApps.length === 1 ? 'resultado' : 'resultados'}
            <button onClick={() => setFailuresFilter(false)} style={{ marginLeft: 2, background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'var(--danger)', display: 'flex', alignItems: 'center' }}><Icon name="x" size={11} /></button>
          </div>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Exibindo apenas integrações com erro ou suspensas</span>
        </div>
      )}

      {/* Last rotation info */}
      {lastRotation && tab === 'tokens' && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 12, fontSize: 12, color: 'var(--success)', background: 'var(--success-bg)', padding: '4px 10px', borderRadius: 20 }}>
          <Icon name="check" size={12} />Última rotação: {lastRotation}
        </div>
      )}

      {tab === 'overview' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          {OVERVIEW_APPS.map(app => (
            <div key={app.name} className="card" style={{ padding: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>{app.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{app.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{app.tenants} tenant{app.tenants !== 1 ? 's' : ''}</div>
                </div>
                <span className={`badge ${app.errors > 0 ? 'danger' : 'success'}`}><span className="dot" />{app.errors > 0 ? `${app.errors} erros` : 'OK'}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--text-muted)' }}>Última requisição</span><span style={{ fontWeight: 500 }}>{app.lastReq}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--text-muted)' }}>Taxa de sucesso</span><span style={{ fontWeight: 600, color: parseFloat(app.rate) >= 90 ? 'var(--success)' : 'var(--danger)' }}>{app.rate}</span></div>
              </div>
              <div style={{ marginTop: 12, display: 'flex', gap: 6 }}>
                <button className="btn sm" style={{ flex: 1, justifyContent: 'center' }} onClick={() => setTab('logs')}><Icon name="activity" size={12} />Logs</button>
                <button className="btn sm" onClick={() => setConfigureApp({ app: app.name, tenant: app.tenants > 0 ? `${app.tenants} tenant${app.tenants !== 1 ? 's' : ''}` : '—', type: '—', version: 'v1.0', status: 'ativo' })}><Icon name="settings" size={12} /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'tokens' && (
        <div className="table-wrap">
          {tenantFilter && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 10, padding: '4px 10px', background: 'var(--info-bg)', borderRadius: 20, fontSize: 12, fontWeight: 600, color: 'var(--info)', border: '1px solid color-mix(in srgb, var(--info) 25%, transparent)' }}>
              <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--info)', flexShrink: 0 }} />
              Tenant: {tenantFilter.name}
              <button onClick={() => setTenantFilter(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'var(--info)', display: 'flex', alignItems: 'center', marginLeft: 2 }}><Icon name="x" size={11} /></button>
            </div>
          )}
          <div className="table-toolbar">
            <div className="search"><Icon name="search" size={15} /><input placeholder="Buscar por label, tenant, app…" /></div>
            <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>
              {tenantFilter ? tokens.filter(t => !t.tenantId || t.tenantId === tenantFilter.id).length : tokens.length} tokens
            </span>
          </div>
          <table className="data">
            <thead>
              <tr><th>Label</th><th>App ID</th><th>Tenant</th><th>Token</th><th>Criado</th><th>Última rotação</th><th>Último uso</th><th>Status</th><th>Escopo</th><th style={{ textAlign: 'right' }}>Ações</th></tr>
            </thead>
            <tbody>
              {(tenantFilter ? tokens.filter(t => !t.tenantId || t.tenantId === tenantFilter.id) : tokens).map(t => {
                const sc = TOKEN_STATUS[t.status] || TOKEN_STATUS.ativo;
                return (
                  <tr key={t.id}>
                    <td style={{ fontWeight: 500 }}>{t.label}</td>
                    <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', background: 'var(--bg-subtle)', padding: '2px 6px', borderRadius: 4 }}>{t.appId}</code></td>
                    <td style={{ fontSize: 13 }}>{t.tenant}</td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)', letterSpacing: '0.03em' }}>{t.masked}</code>
                        <button className="icon-action" title="Ver token completo" onClick={() => setTokenModal(t)}><Icon name="key" size={12} /></button>
                      </div>
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.created}</td>
                    <td style={{ fontSize: 12, color: t.rotated === 'Agora' ? 'var(--success)' : t.rotated === t.created ? 'var(--warning)' : 'var(--text-muted)' }}>{t.rotated}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.lastUsed}</td>
                    <td><span className={`badge ${sc.cls}`}><span className="dot" />{sc.label}</span></td>
                    <td>
                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        {t.scope.slice(0, 2).map(s => <span key={s} style={{ fontSize: 10, background: 'var(--info-bg)', color: 'var(--info)', padding: '2px 6px', borderRadius: 4, fontWeight: 600, fontFamily: 'JetBrains Mono, monospace' }}>{s}</span>)}
                        {t.scope.length > 2 && <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>+{t.scope.length - 2}</span>}
                      </div>
                    </td>
                    <td>
                      <div className="row-actions">
                        <button className="icon-action" title="Rotacionar" onClick={() => setRotateOpen(true)}><Icon name="refresh" size={13} /></button>
                        <button className="icon-action danger" title="Revogar" onClick={() => { setTokens(prev => prev.map(x => x.id === t.id ? { ...x, status: 'revogado' } : x)); onToast && onToast(`Token revogado`); logAction && logAction({ acao: `Token revogado: ${t.label}`, loja: t.tenant, kind: 'danger' }); }}><Icon name="x" size={13} /></button>
                        <button className="icon-action" title="Ver logs" onClick={() => setTab('logs')}><Icon name="activity" size={13} /></button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'apps' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <div className="search"><Icon name="search" size={15} /><input placeholder="Buscar por app, tenant…" /></div>
          </div>
          <table className="data">
            <thead><tr><th>App</th><th>Tipo</th><th>Tenant</th><th>Status</th><th>Instalado</th><th>Última sync</th><th>Último erro</th><th>Versão</th><th style={{ textAlign: 'right' }}>Ações</th></tr></thead>
            <tbody>
              {filteredApps.map((a, i) => {
                const appKey = a.app + '|' + a.tenant;
                const appData = { ...a, ...(appsLocal[appKey] || {}) };
                const sc = APP_STATUS[appData.status] || APP_STATUS.ativo;
                return (
                  <tr key={i}>
                    <td style={{ fontWeight: 600 }}>{appData.app}</td>
                    <td><span style={{ fontSize: 11, background: 'var(--bg-subtle)', padding: '2px 7px', borderRadius: 4, color: 'var(--text-secondary)' }}>{appData.type}</span></td>
                    <td>{appData.tenant}</td>
                    <td>
                      <span className={`badge ${sc.cls}`}><span className="dot" />{sc.label}</span>
                      {appsLocal[appKey]?.statusLabel && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 3, fontStyle: 'italic' }}>{appsLocal[appKey].statusLabel}</div>}
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{appData.installed}</td>
                    <td style={{ fontSize: 12, color: appData.synced === 'Agora' ? 'var(--success)' : 'var(--text-muted)' }}>{appData.synced}</td>
                    <td style={{ fontSize: 12, color: appData.error ? 'var(--danger)' : 'var(--text-muted)' }}>{appData.error || '—'}</td>
                    <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{appData.version}</code></td>
                    <td>
                      <div className="row-actions">
                        <button className="icon-action" title="Reprocessar integração" onClick={() => setReprocessApp(a)}><Icon name="refresh" size={13} /></button>
                        {(a.status === 'erro' || appData.status === 'erro') && <button className="icon-action" title="Reinstalar app" onClick={() => setReinstallApp(a)}><Icon name="package" size={13} /></button>}
                        <button className="icon-action" title="Configurar app" onClick={() => setConfigureApp(a)}><Icon name="settings" size={13} /></button>
                        <button className="icon-action" title="Logs" onClick={() => setTab('logs')}><Icon name="activity" size={13} /></button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'webhooks' && (
        <div className="table-wrap">
          <table className="data">
            <thead><tr><th>Tenant</th><th>Evento</th><th>URL</th><th>Status</th><th>Última entrega</th><th>Taxa sucesso</th><th>Próx. retry</th><th style={{ textAlign: 'right' }}>Ações</th></tr></thead>
            <tbody>
              {WEBHOOKS_MOCK.map((w, i) => {
                const wKey  = w.tenant + '|' + w.event;
                const local = webhooksLocal[wKey] || {};
                const wData = { ...w, ...local };
                const isPaused = wData.status === 'pausado';
                return (
                  <tr key={i}>
                    <td style={{ fontWeight: 500 }}>{wData.tenant}</td>
                    <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', background: 'var(--info-bg)', color: 'var(--info)', padding: '2px 6px', borderRadius: 4 }}>{wData.event}</code></td>
                    <td style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{wData.url}</td>
                    <td>
                      <span className={`badge ${wData.status === 'ativo' ? 'success' : wData.status === 'falha' ? 'danger' : 'neutral'}`}><span className="dot" />{wData.status}</span>
                      {local.lastEdit   && <div style={{ fontSize:10, color:'var(--text-muted)', marginTop:2, fontStyle:'italic' }}>Editado agora</div>}
                      {local.lastResend && <div style={{ fontSize:10, color:'var(--success)',    marginTop:2, fontStyle:'italic' }}>Reenviado agora</div>}
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{wData.delivered}</td>
                    <td style={{ fontWeight: 600, color: parseFloat(wData.rate) >= 90 ? 'var(--success)' : 'var(--danger)' }}>{wData.rate}</td>
                    <td style={{ fontSize: 12, color: wData.retry ? 'var(--warning)' : 'var(--text-muted)' }}>{wData.retry || '—'}</td>
                    <td>
                      <div className="row-actions">
                        <button className="icon-action" title="Testar webhook"  onClick={() => setWebhookTest(w)}><Icon name="zap"     size={13} /></button>
                        <button className="icon-action" title="Reenviar evento" onClick={() => setWebhookResend(w)}><Icon name="refresh" size={13} /></button>
                        <button className="icon-action" title="Editar webhook"  onClick={() => setWebhookEdit(w)}><Icon name="edit"    size={13} /></button>
                        <button className={`icon-action${isPaused ? '' : ' danger'}`} title={isPaused ? 'Reativar webhook' : 'Pausar webhook'} onClick={() => setWebhookPause({ webhook: w, isPaused })}><Icon name={isPaused ? 'play' : 'suspend'} size={13} /></button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'logs' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <div className="search"><Icon name="search" size={15} /><input placeholder="Buscar endpoint, tenant, request ID…" /></div>
            <select className="select"><option>Todos os status</option><option>2xx</option><option>4xx</option><option>5xx</option></select>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={onlyErrors} onChange={e => setOnlyErrors(e.target.checked)} style={{ accentColor: 'var(--danger)' }} />Apenas erros
            </label>
          </div>
          <table className="data">
            <thead><tr><th>Data/hora</th><th>Tenant</th><th>App ID</th><th>Endpoint</th><th>Método</th><th>Status</th><th>Latência</th><th>Request ID</th></tr></thead>
            <tbody>
              {API_LOGS_MOCK.filter(l => !onlyErrors || l.status >= 400).map((l, i) => (
                <tr key={i}>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{l.ts}</td>
                  <td style={{ fontSize: 13 }}>{l.tenant}</td>
                  <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{l.appId}</code></td>
                  <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>{l.endpoint}</code></td>
                  <td><span style={{ fontSize: 11, fontWeight: 700, fontFamily: 'JetBrains Mono, monospace', background: 'var(--bg-subtle)', padding: '2px 6px', borderRadius: 4 }}>{l.method}</span></td>
                  <td><span style={{ fontSize: 12, fontWeight: 700, color: l.status >= 500 ? 'var(--danger)' : l.status >= 400 ? 'var(--warning)' : 'var(--success)' }}>{l.status}</span></td>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{l.latency}</td>
                  <td><code style={{ fontSize: 10, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{l.reqId}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'security' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[
            { title: 'Tokens sem rotação há 90d',    items: tokens.filter(t => t.rotated === t.created).map(t => t.label), icon: 'clock', cls: 'warning' },
            { title: 'Tokens revogados recentemente', items: tokens.filter(t => t.status === 'revogado').map(t => t.label), icon: 'x',    cls: 'neutral', empty: 'Nenhum token revogado recentemente.' },
            { title: 'Apps com falhas recorrentes',   items: APPS_MOCK.filter(a => a.status === 'erro').map(a => `${a.app} — ${a.tenant}`), icon: 'alert', cls: 'danger' },
            { title: 'Tentativas inválidas (24h)',     items: ['401 · tiny_v3 · 3 tentativas','403 · gmc_v1 · 1 tentativa'], icon: 'lock', cls: 'danger' },
          ].map(sec => (
            <div key={sec.title} className="card">
              <div className="card-head">
                <div style={{ width: 28, height: 28, borderRadius: 6, background: sec.cls === 'danger' ? 'var(--danger-bg)' : sec.cls === 'warning' ? 'var(--warning-bg)' : 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Icon name={sec.icon} size={14} style={{ color: sec.cls === 'danger' ? 'var(--danger)' : sec.cls === 'warning' ? 'var(--warning)' : 'var(--text-muted)' }} />
                </div>
                <h3 style={{ fontSize: 13 }}>{sec.title}</h3>
                {sec.items.length > 0 && <span className={`badge ${sec.cls}`} style={{ marginLeft: 'auto' }}>{sec.items.length}</span>}
              </div>
              <div className="card-body" style={{ padding: '12px 16px' }}>
                {sec.items.length === 0
                  ? <div className="hint-card"><Icon name="check" size={14} style={{ color: 'var(--success)' }} />{sec.empty || 'Nenhuma ocorrência.'}</div>
                  : sec.items.map((item, i) => (
                    <div key={i} style={{ padding: '8px 0', borderBottom: i < sec.items.length-1 ? '1px solid var(--border)' : 'none', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span>{item}</span>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="btn sm" onClick={() => setRotateOpen(true)}><Icon name="refresh" size={11} /></button>
                        <button className="btn sm danger-outline" onClick={() => { onToast && onToast('Item revogado'); logAction && logAction({ acao: `Revogou: ${item}`, loja: '—', kind: 'danger' }); }}><Icon name="x" size={11} /></button>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modals */}
      <TokenSecurityModal open={!!tokenModal} token={tokenModal} onClose={() => setTokenModal(null)} logAction={logAction} onToast={onToast} />
      <ApiDocDrawer open={apiDocOpen} onClose={() => setApiDocOpen(false)} onToast={onToast} />
      <RotateTokensModal open={rotateOpen} onClose={() => setRotateOpen(false)} onRotated={handleRotated} onToast={onToast} logAction={logAction} />
      <NewTokenDrawer open={newTokenOpen} onClose={() => setNewTokenOpen(false)} onCreated={tok => setTokens(prev => [tok, ...prev])} logAction={logAction} />
      <ReprocessIntegrationModal
        open={!!reprocessApp} app={reprocessApp} onClose={() => setReprocessApp(null)}
        onConfirm={app => {
          const key = app.app + '|' + app.tenant;
          setAppsLocal(p => ({ ...p, [key]: { ...p[key], status: 'ativo', synced: 'Agora', statusLabel: 'Reprocessado agora', error: null } }));
          logAction && logAction({ acao: `Integração reprocessada: ${app.app}`, loja: app.tenant, kind: 'info' });
          onToast && onToast(`${app.app} reprocessado com sucesso`);
        }}
      />
      <ReinstallAppModal
        open={!!reinstallApp} app={reinstallApp} onClose={() => setReinstallApp(null)}
        onConfirm={app => {
          const key = app.app + '|' + app.tenant;
          setAppsLocal(p => ({ ...p, [key]: { ...p[key], status: 'ativo', synced: 'Agora', statusLabel: 'Reinstalado agora', error: null } }));
          logAction && logAction({ acao: `App reinstalado: ${app.app}`, loja: app.tenant, kind: 'info' });
          onToast && onToast(`${app.app} reinstalado com sucesso`);
        }}
      />
      <ConfigureAppDrawer
        open={!!configureApp} app={configureApp} onClose={() => setConfigureApp(null)}
        onSave={(app, cfg) => {
          const key = app.app + '|'+ app.tenant;
          const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
          setAppsLocal(p => ({ ...p, [key]: { ...p[key], statusLabel: `Configurado · ${now}`, status: cfg.status === 'inativo' ? 'suspenso' : 'ativo' } }));
          logAction && logAction({ acao: `App configurado: ${app.app}`, loja: app.tenant, kind: 'info' });
          onToast && onToast(`Configurações de ${app.app} salvas`);
        }}
      />

      {/* Webhook modals */}
      <WebhookTestModal
        open={!!webhookTest} webhook={webhookTest}
        onClose={() => setWebhookTest(null)} onToast={onToast}
      />
      <WebhookResendModal
        open={!!webhookResend} webhook={webhookResend}
        onClose={() => setWebhookResend(null)}
        onConfirm={wh => {
          const key = wh.tenant + '|' + wh.event;
          const ts  = new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
          setWebhooksLocal(p => ({ ...p, [key]: { ...p[key], status: 'ativo', delivered: `Há pouco (${ts})`, lastResend: true, retry: null } }));
          logAction && logAction({ acao: `Webhook reenviado: ${wh.event}`, loja: wh.tenant, kind: 'info' });
          onToast && onToast(`Evento reenviado: ${wh.event}`);
        }}
      />
      <WebhookEditDrawer
        open={!!webhookEdit} webhook={webhookEdit}
        onClose={() => setWebhookEdit(null)}
        onSave={(wh, form) => {
          const key = wh.tenant + '|' + wh.event;
          setWebhooksLocal(p => ({ ...p, [key]: { ...p[key], status: form.status === 'inativo' ? 'pausado' : 'ativo', lastEdit: true } }));
          logAction && logAction({ acao: `Webhook editado: ${wh.event}`, loja: wh.tenant, kind: 'info' });
          onToast && onToast(`Webhook atualizado: ${wh.event}`);
        }}
      />
      <WebhookPauseModal
        open={!!webhookPause} webhook={webhookPause?.webhook} isPaused={webhookPause?.isPaused}
        onClose={() => setWebhookPause(null)}
        onConfirm={wh => {
          const key       = wh.tenant + '|' + wh.event;
          const wasPaused = webhookPause?.isPaused;
          const newStatus = wasPaused ? 'ativo' : 'pausado';
          setWebhooksLocal(p => ({ ...p, [key]: { ...p[key], status: newStatus } }));
          logAction && logAction({ acao: `Webhook ${wasPaused ? 'reativado' : 'pausado'}: ${wh.event}`, loja: wh.tenant, kind: 'info' });
          onToast && onToast(`Webhook ${wasPaused ? 'reativado' : 'pausado'}: ${wh.event}`);
        }}
      />
    </div>
  );
};

export {
  IntegrationsPage,
};
